var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_322_27593"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_322_27593)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.375,5.83338810546875C39.375,7.12838810546875,38.8121,8.29213810546875,37.9167,9.094228105468751L37.9167,14.58340810546875L52.5,14.58340810546875C57.3325,14.58340810546875,61.25,18.50090810546875,61.25,23.33340810546875L61.25,52.50000810546875C61.25,57.33250810546875,57.3325,61.25000810546875,52.5,61.25000810546875L17.5,61.25000810546875C12.6675,61.25000810546875,8.75,57.33250810546875,8.75,52.50000810546875L8.75,23.33340810546875C8.75,18.50090810546875,12.6675,14.58340810546875,17.5,14.58340810546875L32.0833,14.58340810546875L32.0833,9.094228105468751C29.7203,6.98063810546875,30.3198,3.1337381054687503,33.214,1.8394651054687499C36.1081,0.54514610546875,39.375,2.66295810546875,39.375,5.83338810546875ZM0,29.16670810546875L5.83333,29.16670810546875L5.83333,46.66670810546875L0,46.66670810546875L0,29.16670810546875ZM70,29.16670810546875L64.1667,29.16670810546875L64.1667,46.66670810546875L70,46.66670810546875L70,29.16670810546875ZM26.25,42.29170810546875C28.6662,42.29170810546875,30.625,40.33300810546875,30.625,37.91670810546875C30.625,35.50050810546875,28.6662,33.54170810546875,26.25,33.54170810546875C23.8338,33.54170810546875,21.875,35.50050810546875,21.875,37.91670810546875C21.875,40.33300810546875,23.8338,42.29170810546875,26.25,42.29170810546875ZM48.125,37.91670810546875C48.125,35.50050810546875,46.1662,33.54170810546875,43.75,33.54170810546875C41.3337,33.54170810546875,39.375,35.50050810546875,39.375,37.91670810546875C39.375,40.33300810546875,41.3337,42.29170810546875,43.75,42.29170810546875C46.1662,42.29170810546875,48.125,40.33300810546875,48.125,37.91670810546875Z",
    fill: "#a277ee",
    fillOpacity: 0.05000000074505806
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotBg);
export default __webpack_public_path__ + "static/media/robot_bg.e6267c59c8f901211bb3bb3148466a46.svg";
export { ForwardRef as ReactComponent };